export default {
  name: 'misc.occupation',
  key: 'occupation',
  attributes: {
    serfs: {
      key: 'serfs',
      name: 'entity.gasGiantMine.occupation.serfs',
    },
    robots: {
      key: 'robots',
      name: 'entity.gasGiantMine.occupation.robots',
    },
    alien: {
      key: 'alien',
      name: 'entity.gasGiantMine.occupation.alien',
    },
    mine: {
      key: 'mine',
      name: 'entity.gasGiantMine.occupation.mine',
    },
    group: {
      key: 'group',
      name: 'entity.gasGiantMine.occupation.group',
    },
  },
};
